import styled from '@emotion/styled'

import { WithTheme } from './../../../setup/index'
import media from './../../../common/MediaQueries'

const TableSearchFormStyled = styled.form<WithTheme>`
  display: inline-flex;
  height: 2.625rem;
  border: 0.0625rem solid #d5e05b;
  border-radius: 0.3125rem;
  width: 100%;
  max-width: 18.875rem;

  @media ${media.tablet} {
    max-width: 100%;
  }
`

const TableSearchFormContentStyled = styled.div`
  display: inline-flex;
  justify-content: space-between;
  padding: 0.625rem 0.9375rem;
  width: 100%;

  @media ${media.tablet} {
    padding: 0.625rem 1.625rem;
  }
`

const TableSearchFormInputStyled = styled.input<WithTheme>`
  border: 0;
  font-size: 1rem;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.black};
  outline: 0;
  padding: 0 1rem 0 0;
  width: 100%;

  /* PLACEHOLDER */
  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.gray2};
  }
  &:-moz-placeholder {
    color: ${({ theme }) => theme.colors.gray2};
  }
  &:-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.gray2};
  }

  &:focus {
    outline: none;
  }

  @media ${media.tablet} {
    width: 100%;
    padding-right: 0;
  }
`

const TableSearchFormButtonStyled = styled.button<WithTheme>`
  color: ${({ theme }) => theme.colors.green};
  border: none;
  background: none;
  cursor: pointer;
  @media ${media.tablet} {
    display: none;
  }
`

export { TableSearchFormStyled, TableSearchFormContentStyled, TableSearchFormInputStyled, TableSearchFormButtonStyled }
